export default [
    { id: 'Lines', label: 'Lines', parent: '' },
    { id: 'LineDetails', label: 'Line Details', parent: 'Lines' },
    { id: 'CreditNoteDetails', label: 'Credit Note Details', parent: '' },
    { id: 'Notes', label: 'Notes', parent: '' },
    { id: 'KitComponents', label: 'Kit Components', parent: 'LineDetails' },
    { id: 'ComponentDetails', label: 'Component Details', parent: 'KitComponents' },
];
